// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HYpd","content":"styles_content__1ZuSJ","tableWrap":"styles_tableWrap__5fNYo"};